// HPC Report - PartDPage1 (Read-only displays for HPC Report)
import React from 'react';

const PartDPage1 = ({ data }) => {
  const teacherFields = data?.teacher_fields || {};
  const studentFields = data?.student_fields || {};

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      margin: '0 auto',
      padding: '20mm',
      backgroundColor: 'white',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      position: 'relative',
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      {/* Top-right corner */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #F4824C transparent transparent'
      }} />

      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '8px' }}>
        <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#F4824C', marginBottom: '5px' }}>
          PART D
        </div>
      </div>
      <div style={{
        fontSize: '13px',
        fontWeight: 'bold',
        textAlign: 'center',
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '8px',
        marginBottom: '15px'
      }}>
        Observation Template for Classroom Interactions
      </div>

      {/* Interaction Types */}
      <div style={{
        backgroundColor: '#FFE5D5',
        padding: '12px',
        marginBottom: '12px'
      }}>
        <div style={{ fontWeight: 'bold', fontSize: '10px', marginBottom: '8px' }}>
          Tick (✓) the type of classroom interaction.
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px', fontSize: '9px' }}>
          {teacherFields.interaction_types?.classroom_discussion && <div>☑ Classroom discussion</div>}
          {teacherFields.interaction_types?.organised_debate && <div>☑ Organised debate</div>}
          {teacherFields.interaction_types?.simulation_role_play && <div>☑ Simulation/role play</div>}
          {teacherFields.interaction_types?.lab_experiment && <div>☑ Lab experiment</div>}
          {teacherFields.interaction_types?.digital_learning && <div>☑ Digital learning</div>}
          {teacherFields.interaction_types?.custom && <div>☑ {teacherFields.interaction_types.custom}</div>}
        </div>
      </div>

      {/* Subject(s) */}
      <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', marginBottom: '12px' }}>
        <div style={{
          backgroundColor: '#F4824C',
          color: 'white',
          padding: '8px 15px',
          borderRadius: '20px',
          fontSize: '10px',
          fontWeight: 'bold',
          textAlign: 'center',
          minWidth: '140px'
        }}>
          <div>Subject(s)</div>
          <div style={{ fontSize: '8px', fontWeight: 'normal' }}>(Can be more than one)</div>
        </div>
        <div style={{
          flex: 1,
          backgroundColor: '#FFE5D5',
          padding: '8px',
          fontSize: '9px'
        }}>
          {teacherFields.subjects && teacherFields.subjects.length > 0
            ? teacherFields.subjects.join(', ')
            : ''}
        </div>
      </div>

      {/* Curricular goal(s) */}
      <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', marginBottom: '12px' }}>
        <div style={{
          backgroundColor: '#F4824C',
          color: 'white',
          padding: '8px 15px',
          borderRadius: '20px',
          fontSize: '10px',
          fontWeight: 'bold',
          textAlign: 'center',
          minWidth: '140px'
        }}>
          <div>Curricular goal(s)</div>
          <div style={{ fontSize: '8px', fontWeight: 'normal' }}>(Can be more than one)</div>
        </div>
        <div style={{
          flex: 1,
          backgroundColor: '#FFE5D5',
          padding: '8px',
          fontSize: '9px'
        }}>
          {teacherFields.curricular_goals && teacherFields.curricular_goals.length > 0
            ? teacherFields.curricular_goals.join(', ')
            : ''}
        </div>
      </div>

      {/* Competency(-ies) */}
      <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', marginBottom: '12px' }}>
        <div style={{
          backgroundColor: '#F4824C',
          color: 'white',
          padding: '8px 15px',
          borderRadius: '20px',
          fontSize: '10px',
          fontWeight: 'bold',
          textAlign: 'center',
          minWidth: '140px'
        }}>
          <div>Competency(-ies)</div>
          <div style={{ fontSize: '8px', fontWeight: 'normal' }}>(Can be more than one)</div>
        </div>
        <div style={{
          flex: 1,
          backgroundColor: '#FFE5D5',
          padding: '8px',
          fontSize: '9px'
        }}>
          {teacherFields.competencies && teacherFields.competencies.length > 0
            ? teacherFields.competencies.join(', ')
            : ''}
        </div>
      </div>

      {/* Pedagogies */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '12px' }}>
        <div style={{
          backgroundColor: '#F4824C',
          color: 'white',
          padding: '10px 15px',
          fontSize: '10px',
          fontWeight: 'bold',
          textAlign: 'center',
          minWidth: '140px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}>
          <div>Pedagogies</div>
          <div style={{ fontSize: '8px', fontWeight: 'normal' }}>(Tick (✓) all that apply.)</div>
        </div>
        <div style={{
          flex: 1,
          backgroundColor: '#FFE5D5',
          padding: '10px',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '6px',
          fontSize: '9px'
        }}>
          {teacherFields.pedagogies?.art_integrated && <div>☑ Art-integrated</div>}
          {teacherFields.pedagogies?.sports_integrated && <div>☑ Sports-integrated</div>}
          {teacherFields.pedagogies?.toy_based && <div>☑ Toy-based</div>}
          {teacherFields.pedagogies?.technology_integrated && <div>☑ Technology-integrated</div>}
          {teacherFields.pedagogies?.skill_based_learning && <div>☑ Skill-based learning</div>}
          {teacherFields.pedagogies?.drama_theatre_integrated && <div>☑ Drama/Theatre-integrated</div>}
          {teacherFields.pedagogies?.indian_knowledge_systems && (
            <div style={{ gridColumn: '1 / -1' }}>☑ Indian Knowledge Systems approaches</div>
          )}
          {teacherFields.pedagogies?.any_other && (
            <div style={{ gridColumn: '1 / -1' }}>☑ {teacherFields.pedagogies.any_other}</div>
          )}
        </div>
      </div>

      {/* Topic/Theme and Duration */}
      <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', marginBottom: '12px' }}>
        <div style={{ flex: 1 }}>
          <div style={{
            backgroundColor: '#F4824C',
            color: 'white',
            padding: '6px 15px',
            borderRadius: '20px',
            fontSize: '9px',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '6px',
            lineHeight: '1.3'
          }}>
            Topic/theme/prompt/question/problem/challenge/planned final output
          </div>
          <div style={{
            backgroundColor: '#FFE5D5',
            padding: '8px',
            fontSize: '9px',
            minHeight: '50px'
          }}>
            {teacherFields.topic_theme || ''}
          </div>
        </div>
        <div style={{ width: '100px' }}>
          <div style={{
            fontWeight: 'bold',
            fontSize: '10px',
            marginBottom: '6px',
            textAlign: 'center'
          }}>
            Duration
          </div>
          <div style={{
            backgroundColor: '#FFE5D5',
            padding: '8px',
            fontSize: '9px',
            textAlign: 'center',
            minHeight: '50px'
          }}>
            {teacherFields.duration || ''}
          </div>
        </div>
      </div>

      {/* Blue Boxes - Student fields */}
      <div style={{ textAlign: 'center', marginBottom: '10px' }}>
        <svg width="30" height="25" viewBox="0 0 30 25">
          <path d="M 15 3 L 15 18 M 15 18 L 10 13 M 15 18 L 20 13" stroke="#5B9BD5" strokeWidth="3" fill="none" />
        </svg>
      </div>

      <div style={{ display: 'flex', gap: '12px', position: 'relative', marginBottom: '20px' }}>
        <div style={{ flex: 1 }}>
          <div style={{
            backgroundColor: '#5B9BD5',
            color: 'white',
            padding: '8px',
            fontSize: '10px',
            fontWeight: 'bold',
            textAlign: 'center'
          }}>
            Prior Preparation / Planning / Review / Recap
          </div>
          <div style={{
            backgroundColor: '#BDD7EE',
            padding: '10px',
            fontSize: '9px',
            minHeight: '100px',
            border: '1px solid #5B9BD5'
          }}>
            {studentFields.prior_preparation || ''}
          </div>
        </div>

        <div style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}>
          <svg width="35" height="20" viewBox="0 0 35 20">
            <path d="M 0 10 L 28 10 M 28 10 L 23 5 M 28 10 L 23 15" stroke="#5B9BD5" strokeWidth="2.5" fill="none" />
          </svg>
        </div>

        <div style={{ flex: 1 }}>
          <div style={{
            backgroundColor: '#5B9BD5',
            color: 'white',
            padding: '8px',
            fontSize: '10px',
            fontWeight: 'bold',
            textAlign: 'center'
          }}>
            Materials needed (if applicable)
          </div>
          <div style={{
            backgroundColor: '#BDD7EE',
            padding: '10px',
            fontSize: '9px',
            minHeight: '100px',
            border: '1px solid #5B9BD5'
          }}>
            {studentFields.materials_needed || ''}
          </div>
        </div>
      </div>

      {/* Page Number */}
      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '11px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        31
      </div>

      {/* Bottom corners */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #F4824C'
      }} />
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 60px 0 0',
        borderColor: 'transparent #F4824C transparent transparent',
        opacity: 0.3
      }} />
    </div>
  );
};

export default PartDPage1;
